import { offerDataSelector } from './offerDataSelector';
import { IState } from '../../store';
import { IOffer } from '../../types/offerData';

export const selectOffer = (state: IState): IOffer => {
  const offerData = offerDataSelector(state);

  return offerData.offer;
};
